// extracted by mini-css-extract-plugin
export default {"committeeList":"committee-list-section_committeeList__FsT6u"};